import { render } from "./UserRewards.vue?vue&type=template&id=2e45755e"
import script from "./UserRewards.vue?vue&type=script&lang=js"
export * from "./UserRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__